import React from 'react';
import ImagePreviewButton from './ImagePreviewButton';
import ImagePreviewCTA from './ImagePreviewCTA';
import { ProgressOverlay } from '../../../../../app/components/progress';
import ThumbsContainer from './ThumbsContainer';

const ImagePreview = ({ handleClick, pending, sources, deleteImage, mainImage, onChangeMainImage }) => {
    const cta = !pending && (
        <ImagePreviewCTA>Upload Images</ImagePreviewCTA>
    );
    const loader = pending && <ProgressOverlay />;
    return <div>
        <ImagePreviewButton
            disabled={pending}
            onClick={handleClick}
        >
            {cta}
            {loader}
        </ImagePreviewButton>
        <ThumbsContainer sources={sources} deleteImage={deleteImage} mainImage={mainImage} onChangeMainImage={onChangeMainImage} />
    </div>
}

export default ImagePreview;
